import { AxiosInstance } from "axios";
import type { GitHubRepository } from "./GitHubSourceSettings.types";

export class GitHubSourceSettingsApi {
  constructor(private readonly client: AxiosInstance) {}

  async getRepositories(
    boardId: string,
    connectionId: string,
  ): Promise<GitHubRepository[]> {
    const response = await this.client.get<GitHubRepository[]>(
      `/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/github/repositories`,
    );

    return response.data;
  }
}
